import { useEffect } from "react";

export default function useGoogleAnalytics() {
  useEffect(() => {
    // Si por alguna razón corre fuera del navegador, no hagas nada
    if (typeof window === "undefined" || typeof document === "undefined") return;

    const id = "G-TFFJ8W8PP6";

    // Si no hay ID, NO rompas la app (solo no cargues GA)
    if (!id || !String(id)?.startsWith("G-")) return;

    // Evita re-inyectar el script
    if (document.getElementById("ga-gtag")) {
      if (typeof window.gtag === "function") window.gtag("config", id);
      return;
    }

    // Carga gtag
    const s = document.createElement("script");
    s.id = "ga-gtag";
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head?.appendChild(s);

    // Inicializa dataLayer + gtag
    window.dataLayer = window.dataLayer || [];
    function gtag(...args) {
      window.dataLayer?.push(args);
    }
    window.gtag = window.gtag || gtag;

    window.gtag("js", new Date());
    window.gtag("config", id);
  }, []);
}